import React from 'react';
import styles from './ProfitLossReportTable.module.css';

const ProfitLossReportTable = ({ bets }) => {
  if (!bets || bets.length === 0) {
    return (
      <div className={styles.noData}>
        No bets found for this market.
      </div>
    );
  }



  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <thead className={styles.thead}>
          <tr>
            <th scope="col" className={styles.th}>Member</th>
            <th scope="col" className={styles.th}>Placed</th>
            <th scope="col" className={styles.th}>Selection</th>
            <th scope="col" className={styles.th}>Type</th>
            <th scope="col" className={styles.th}>Currency</th>
            <th scope="col" className={`${styles.th} ${styles.textRight}`}>Odds</th>
            <th scope="col" className={`${styles.th} ${styles.textRight}`}>Stake</th>
            <th scope="col" className={styles.th}>Status</th>
            <th scope="col" className={`${styles.th} ${styles.textRight}`}>Member Win/Loss</th>
          </tr>
        </thead>
        <tbody>
          {bets.map((bet, index) => (
            <tr 
              key={bet.bet_id || index} 
              className={styles.tr}
            >
              <td className={`${styles.td} ${styles.tdMedium}`}>
                {bet.username || bet.user_id || '-'}
              </td>
              <td className={styles.td}>
                {bet.settled_at ? new Date(bet.settled_at).toLocaleString() : '-'}
              </td>
              <td className={styles.td}>
                {bet.selection}
              </td>
              <td className={styles.td} style={{ textTransform: 'uppercase' }}>
                {bet.bet_type || bet.type}
              </td>
              <td className={styles.td}>
                INR
              </td>
              <td className={`${styles.td} ${styles.textRight}`}>
                {bet.odds}
              </td>
              <td className={`${styles.td} ${styles.textRight}`}>
                {parseFloat(bet.stake).toFixed(2)}
              </td>
              <td className={`${styles.td} ${styles.fontBold} ${parseFloat(bet.netamount) >= 0 ? styles.textGreen : styles.textRed}`}>
                {parseFloat(bet.netamount) >= 0 ? 'WIN' : 'LOSS'}
              </td>
              <td className={`${styles.td} ${styles.textRight} ${styles.fontBold} ${parseFloat(bet.netamount) >= 0 ? styles.textGreen : styles.textRed}`}>
                {parseFloat(bet.netamount).toFixed(2)}
              </td>
            </tr>
          ))}

        </tbody>
      </table>
    </div>
  );
};

export default ProfitLossReportTable;
